import variables from '../variables'

import type { InputOverrideToken } from './types'

const Input: InputOverrideToken = {
  colorText: variables.baseBlack,
  colorTextPlaceholder: variables.gray40
} as const

export default Input
